import { render, staticRenderFns } from "./LoginPageWithTab.vue?vue&type=template&id=180a1e06&"
import script from "./LoginPageWithTab.vue?vue&type=script&lang=ts&"
export * from "./LoginPageWithTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports